import { Component, OnInit } from '@angular/core';
import { HeaderComponent } from '@shared/components/header/header.component';
import { ActivatedRoute, ParamMap, RouterOutlet } from '@angular/router';
import { ChargeInformationDto, ChargeInformationService } from '@app/api/dmc';
import { generateNavItems } from '@app/core/utils/generate-nav-items';
import {
  chargeinformationNavItems
} from '@views/chargeInformation/chargeinformation-details/chargeinformation-nav-items';
import { NavItem } from '@shared/interfaces/nav/nav-item';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-chargeinformation-details',
  imports: [
    HeaderComponent,
    RouterOutlet,
    TranslatePipe
  ],
  templateUrl: './chargeinformation-details.component.html',
  styleUrl: './chargeinformation-details.component.css'
})
export class ChargeinformationDetailsComponent implements OnInit {
  public id!: string;
  public chargeInformation?: ChargeInformationDto;
  public navItems: NavItem[] = [];

  constructor(
    private readonly route: ActivatedRoute,
    private readonly chargeInformationService: ChargeInformationService,
  ) {
  }

  public ngOnInit(): void {
    this.route.paramMap.subscribe((q: ParamMap) => {
      this.id = q.get('id')!;

      this.chargeInformationService.chargeInformationGetByIdGet(this.id).subscribe((chargeInformation: ChargeInformationDto) => {
        this.chargeInformation = chargeInformation;
        this.navItems = generateNavItems(chargeinformationNavItems, 'id', this.id);
      });
    });
  }
}
